import { render, staticRenderFns } from "./DashboardElementPrimary.vue?vue&type=template&id=50825ce9&scoped=true&"
import script from "./DashboardElementPrimary.vue?vue&type=script&lang=js&"
export * from "./DashboardElementPrimary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50825ce9",
  null
  
)

export default component.exports